import axiosIns from '@/libs/axios'
import { objectToUrlParam } from '@/libs/helper'

export default class PammApis {
  getAllGroups = async data => await axiosIns.get(`${process.env.VUE_APP_FOREX_BASE_API_URL}/forex/platform/groups${objectToUrlParam(data)}`);

  createAccount = async data => await axiosIns.post(`${process.env.VUE_APP_FOREX_BASE_API_URL}/forex/platform/account/create`, data);
}
